// extracted by css-extract-rspack-plugin
export default {"badge":"bWAYGuDWfQYBL7o_","content":"qZAGk422ec7oOlh0"};